/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PolygonIcon = ({ width = 24, height = 24, hidden = false, title = 'Polygon' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M34.61 17.53 26.942 4.565A1.077 1.077 0 0 0 26 4H10.046a1.077 1.077 0 0 0-.946.561l-7.708 12.9a1.079 1.079 0 0 0 0 1.03L9.1 31.438a1.079 1.079 0 0 0 .946.562H26a1.078 1.078 0 0 0 .947-.563l7.666-12.881a1.079 1.079 0 0 0-.003-1.026ZM25.447 30H10.6L3.388 17.98 10.593 6h14.851l7.169 12.04Z"
    />
  </svg>`;
};
